export default __webpack_public_path__ + "static/keyrus-intro-es-8150fc8f6f138e941c35762ce1a5757e.mp4";